import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { CommonService } from '@common/services/common.service';

@Component({
    selector: 'app-accommodation-request-approvals-history-segment',
    templateUrl: './accommodation-request-approvals-history-segment.component.html',
    styleUrls: ['./accommodation-request-approvals-history-segment.component.scss'],
    providers: [CommonService]
})
export class AccommodationRequestApprovalsHistorySegment implements OnInit {
    @Input() model: any;

    ngOnInit(): void {
        
    }  

    get confirmedByFullName(): string {
        return this.model.accommodationRequests?.length > 0
            ? this.model.accommodationRequests[0]?.confirmedBy?.fullName
            : null;
    }

    get agreementDate(): Date | null {
        return this.model.accommodationRequests?.length > 0
            ? this.model.accommodationRequests[0]?.agreementDate
            : null;
    }

    set agreementDate(value: Date | null) {
        if (this.model.accommodationRequests?.length > 0) {
            this.model.accommodationRequests[0].agreementDate = value;
        } 
    }

   get canceledByFullName(): string {
        return this.model.accommodationRequests?.length > 0
            ? this.model.accommodationRequests[0]?.canceledBy?.fullName
            : null;
    }

    get cancelationDate(): Date | null {
        return this.model.accommodationRequests?.length > 0
            ? this.model.accommodationRequests[0]?.canceledDate
            : null;
    }

    set cancelationDate(value: Date | null) {
        if (this.model.accommodationRequests?.length > 0) {
            this.model.accommodationRequests[0].canceledDate = value;
        } 
    }
}
